import { render } from "./schedule-offer.vue?vue&type=template&id=671f9c07"
import script from "./schedule-offer.js?vue&type=script&lang=js"
export * from "./schedule-offer.js?vue&type=script&lang=js"

import "./schedule-offer.vue?vue&type=style&index=0&id=671f9c07&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/schedule-offer.vue'],['render',render],['__file',"schedule-offer.vue"]])

export default __exports__